import React from 'react';
import style from '../../Styles/Html/CheckBox.module.css';
import Enum from '../../Common/Enum/Enum';

const CheckBox = ({ name, id, checked, onChange, isbeverage, isdynamicprice }) => {
    
    return (
        <div className={style.checkBoxContainer}>
            
            <label className={style.switch}>
                <input 
                    type="checkbox" 
                    className={style.targetcheckbox}
                    id={id}
                    checked={checked}  
                    onChange={(e) => onChange(id,e.target.checked)}/>
                    <span className={isbeverage === Enum.ISBEVERAGE ? style.sliderRoundBeverage  : isdynamicprice === Enum.ISDYNAMICPRICE ? style.sliderRoundDynamicPrice : style.sliderRound }></span>
                
            </label>
            <label className={style.checkboxLabel} htmlFor={id}>
                    {name}
            </label>
         
        </div>
    );
};

export default CheckBox;
